import gql from "graphql-tag";

const UPDATE_JOB_CARD_CLASSIFICATION_MUTATION = gql`
  mutation updateJobCardClassificationMutation($jobCardId: Int, $affiliate: String, $classification: String) {
    updateJobCardClassification(affiliate: $affiliate, jobCardId: $jobCardId, classification: $classification)
  }
`;

export { UPDATE_JOB_CARD_CLASSIFICATION_MUTATION };
